import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Select from "react-select";
import { useHistory } from "react-router";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Container,
  Tooltip,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
} from "reactstrap";
import InputPDF from "components/Input/InputPDF";

//helpers
import {
  formateDateApi,
  formateDateandTime,
} from "../../../helpers/formats.js";

// services
import {
  InputCEP,
  InputCNPJ,
  InputCPF,
  InputTELEFONE,
} from "../../../services/mask.js";
import { showMessage, showQuestion } from "../../../services/message.js";
import { api_GET, api_PUT } from "../../../services/api_service.js";
import {
  EnviaProtocoloWithProtocoloGerador,
  EnviaRequerimentoGerador,
} from "../../../services/protocolo_gerador_service.js";
import { GetCEPViaCEP } from "../../../services/viaCep.js";

//Helpers
import { ValidaEmail } from "../../../helpers/email.js";
import {
  isValidCPF,
  isValidDate,
  onlyAlphaNumericAndSpace,
  onlyNumber,
} from "../../../helpers/valid.js";

//Context
import { useAuth } from "../../../context/auth.js";

export default function Identificacao({
  item,
  opcao,
  permiteManutencao,
  handleProximoStep,
  handleReturn,
  setupSolicitacao,
  addNovoGerador = false,
}) {
  const { session, setLoading } = useAuth();

  const { register, handleSubmit, errors, setValue, clearErrors } = useForm({
    mode: "onBlur",
  });

  const history = useHistory();

  const [modal, setModal] = useState(false);
  const toggleModal = () => setModal(!modal);

  const [permiteEditar, set_permiteEditar] = useState(true);

  const [identificacao, set_identificacao] = useState(null);
  const [setupSolicitacaoAcao, set_setupSolicitacaoAcao] = useState(null);
  const [optionsTipoGerador, setOptionsTipoGerador] = useState([
    { value: "Física", label: "Pessoa Física" },
    { value: "Jurídica - MEI", label: "Pessoa Jurídica (MEI)" },
    { value: "Jurídica", label: "Pessoa Jurídica (Privada)" },
    { value: "Pública", label: "Pessoa Jurídica (Pública)" },
  ]);

  // State para pegar a opção do tipo de cadastro
  const [
    setupSolicitacoaAcaoNovoCadastro_Id,
    setSetupSolicitacoaAcaoNovoCadastro_Id,
  ] = useState(null);

  //modal para alteração do tipo do cadastro
  const [modalAlteracaoCadastro, setModalAlteracaoCadastro] = useState(false);
  const toggleAlteracaoCadastroModal = () => {
    setSetupSolicitacoaAcaoNovoCadastro_Id(null);
    setModalAlteracaoCadastro(!modalAlteracaoCadastro);
  };

  // State para pegar as opcoes de setupSolicitacoaAcoes
  const [
    opcoes_SetupSolicitacoaAcaoNovoCadastro,
    setOpcoes_SetupSolicitacoaAcaoNovoCadastro,
  ] = useState([]);
  const loadOpcoesTipoCadastro = (setupSolicitacaoAcaoNovoCadastro_Id) => {
    setLoading(true);
    api_GET(
      `Protocolo/GetOpcoesTipoCadastro/${setupSolicitacaoAcaoNovoCadastro_Id}`
    )
      .then((result) => setOpcoes_SetupSolicitacoaAcaoNovoCadastro(result.data))
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };

  const loadItemRequerimento = () => {
    if (item != null) {
      set_setupSolicitacaoAcao(item.setupSolicitacaoAcao);
      set_identificacao(item);
      setValue("email", item.email);
      setValue("cnpj", item.cpf_Cnpj);
      setValue("nomeSolicitante", item.nomeSolicitante);
      setValue(
        "responsavel",
        item.requerimentoGerador != null && item.requerimentoGerador.length > 0
          ? item?.requerimentoGerador[0].nomeResponsavel
          : item.nomeSolicitante
      );
      setValue("cpf", item.cpf_Cnpj);
      set_categoria(item.setupSolicitacaoAcao.setupSolicitacao.categoria);
      set_tipoGerador(item.setupSolicitacaoAcao.setupSolicitacao.pessoa);
      if (
        item.requerimentoGerador != null &&
        item.requerimentoGerador.length > 0
      ) {
        setValue("fantasia", item.requerimentoGerador[0].nome_Fantasia);
        setValue("razaoSocial", item.requerimentoGerador[0].razaoSocial);
        setValue(
          "nomeResponsavelTecnico",
          item.requerimentoGerador[0].nomeResponsavelTecnico
        );
        setValue(
          "tipoDocumentoResponsavelTecnico",
          item.requerimentoGerador[0].tipoDocumentoResponsavelTecnico
        );
        set_tipoDocumentoResponsavelTecnico(
          item.requerimentoGerador[0].tipoDocumentoResponsavelTecnico,
          true
        );
        setValue(
          "numeroDocumentoResponsavelTecnico",
          item.requerimentoGerador[0].numeroDocumentoResponsavelTecnico
        );
        if (
          item.requerimentoGerador[0].arquivoCertificadoResponsavelTecnico !=
          null
        ) {
          set_file_certificadoCurso({
            name: item.requerimentoGerador[0]
              .arquivoCertificadoResponsavelTecnico,
            base64: null,
            documento_Id: 0,
          });
        }
        setValue("ccm", item.requerimentoGerador[0].ccm);
        setValue("telefone", item.requerimentoGerador[0].telefone);
        setValue("celular", item.requerimentoGerador[0].celular);
        setValue(
          "tipoIndustriaComercio",
          item.requerimentoGerador[0].tipoIndustriaComercio
        );
        setValue("ramo", item.requerimentoGerador[0].ramoAtividade);
        setValue("cep", item.requerimentoGerador[0].cep);
        setValue("logradouro", item.requerimentoGerador[0].logradouro);
        setValue("bairro", item.requerimentoGerador[0].bairro);
        setValue("numEndereco", item.requerimentoGerador[0].numEndereco);
        setValue("complemento", item.requerimentoGerador[0].complemento);
        setValue("cidade", item.requerimentoGerador[0].cidade);
        if (item.requerimentoGerador[0].dataValidadeCadastro != null) {
          setValue(
            "dataValidadeCadastro",
            formateDateApi(item.requerimentoGerador[0].dataValidadeCadastro)
          );
        }
        setValue("uf", item.requerimentoGerador[0].uf);
        setValue("status", item.status, true);
        set_status(item.status);
        setValue(
          "tipoEstabelecimento",
          item.requerimentoGerador[0].tipoEstabelecimento,
          true
        );
        set_tipoEstabelecimento(
          item.requerimentoGerador[0].tipoEstabelecimento
        );
        setValue(
          "qtdeLeitosAtivos",
          item.requerimentoGerador[0].quantidadeLeitosAtivos
        );
        setValue(
          "qtdeLeitosInativos",
          item.requerimentoGerador[0].quantidadeLeitosInativos
        );
        setValue(
          "classificacaoEstabelecimento",
          item.requerimentoGerador[0].classificacaoEstabelecimento,
          true
        );
        set_classificacaoEstabelecimento(
          item.requerimentoGerador[0].classificacaoEstabelecimento
        );
        setValue(
          "subPrefeitura",
          item.requerimentoGerador[0].subPrefeitura,
          true
        );
        set_subPrefeitura(item.requerimentoGerador[0].subPrefeitura);
        set_ramo(item.requerimentoGerador[0].ramoAtividade);

        //Campos novos
        setValue(
          "consumoMensalAgua",
          item.requerimentoGerador[0]?.consumoMensalAgua,
          true
        );
        setConsumoMensalAgua(item.requerimentoGerador[0]?.consumoMensalAgua);

        setValue(
          "consumoMensalEnergia",
          item.requerimentoGerador[0]?.consumoMensalEnergia,
          true
        );
        setConsumoMensalEnergia(
          item.requerimentoGerador[0]?.consumoMensalEnergia
        );

        setValue(
          "localEmpreendimento",
          item.requerimentoGerador[0]?.localEmpreendimento,
          true
        );
        setLocalEmpreendimento(
          item.requerimentoGerador[0]?.localEmpreendimento
        );

        setValue(
          "numeroColaboradores",
          item.requerimentoGerador[0]?.numeroColaboradores,
          true
        );
        setNumeroColaboradores(
          item.requerimentoGerador[0]?.numeroColaboradores
        );

        setValue(
          "areaTotal",
          item.requerimentoGerador[0]?.areaTotal?.toString()?.replace(".", ","),
          true
        );
        setValue(
          "areaConstruida",
          item.requerimentoGerador[0]?.areaConstruida
            ?.toString()
            ?.replace(".", ","),
          true
        );

        setValue(
          "cpfResponsavel",
          item.requerimentoGerador[0]?.cpfResponsavel,
          true
        );
        setValue(
          "funcaoResponsavel",
          item.requerimentoGerador[0]?.funcaoResponsavel,
          true
        );
        setValue(
          "departamentoResponsavel",
          item.requerimentoGerador[0]?.departamentoResponsavel,
          true
        );
        setValue("codigoCNAE", item.requerimentoGerador[0]?.codigoCNAE, true);
        setValue(
          "atividadeCNA",
          item.requerimentoGerador[0]?.atividadeCNA,
          true
        );
      }
    }
  };

  const loadItemProtocolo = () => {
    if (item != null) {
      set_setupSolicitacaoAcao(item.setupSolicitacaoAcaoNovoCadastro);
      set_identificacao(item);
      setValue("email", item.email);
      setValue("cnpj", item.cpf_Cnpj);
      setValue("cpf", item.cpf_Cnpj);
      setValue("nomeSolicitante", item.nomeSolicitante);
      setValue(
        "responsavel",
        item.protocoloGerador != null && item.protocoloGerador.length > 0
          ? item?.protocoloGerador[0].nomeResponsavel
          : item.nomeSolicitante
      );
      set_categoria(
        item.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria
      );
      if (item.protocoloGerador.length > 0) {
        set_tipoGerador(
          item.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.pessoa
        );
        setValue("fantasia", item.protocoloGerador[0].nome_Fantasia);
        setValue("razaoSocial", item.protocoloGerador[0].razaoSocial);
        setValue(
          "nomeResponsavelTecnico",
          item.protocoloGerador[0].nomeResponsavelTecnico
        );
        setValue(
          "tipoDocumentoResponsavelTecnico",
          item.protocoloGerador[0].tipoDocumentoResponsavelTecnico
        );
        set_tipoDocumentoResponsavelTecnico(
          item.protocoloGerador[0].tipoDocumentoResponsavelTecnico,
          true
        );
        setValue(
          "numeroDocumentoResponsavelTecnico",
          item.protocoloGerador[0].numeroDocumentoResponsavelTecnico
        );
        if (
          item.protocoloGerador[0].arquivoCertificadoResponsavelTecnico != null
        ) {
          set_file_certificadoCurso({
            name: item.protocoloGerador[0].arquivoCertificadoResponsavelTecnico,
            base64: null,
            documento_Id: 0,
          });
        }
        setValue("ccm", item.protocoloGerador[0].ccm);
        setValue("codigoCadastro", item.codigoCadastro);
        setValue("telefone", item.protocoloGerador[0].telefone);
        setValue("celular", item.protocoloGerador[0].celular);
        setValue(
          "tipoIndustriaComercio",
          item.protocoloGerador[0].tipoIndustriaComercio
        );
        setValue("ramo", item.protocoloGerador[0].ramoAtividade);
        set_ramo(item.protocoloGerador[0].ramoAtividade);
        setValue("dataFimVigencia", formateDateApi(item.dataFimVigencia));
        setValue("cep", item.protocoloGerador[0].cep);
        setValue("logradouro", item.protocoloGerador[0].logradouro);
        setValue("bairro", item.protocoloGerador[0].bairro);
        setValue("numEndereco", item.protocoloGerador[0].numEndereco);
        setValue("complemento", item.protocoloGerador[0].complemento);
        setValue("cidade", item.protocoloGerador[0].cidade);
        setValue("uf", item.protocoloGerador[0].uf);
        setValue("status", item.status, true);
        set_status(item.status);
        setValue(
          "tipoEstabelecimento",
          item.protocoloGerador[0].tipoEstabelecimento,
          true
        );
        set_tipoEstabelecimento(item.protocoloGerador[0].tipoEstabelecimento);
        setValue(
          "qtdeLeitosAtivos",
          item.protocoloGerador[0].quantidadeLeitosAtivos
        );
        setValue(
          "qtdeLeitosInativos",
          item.protocoloGerador[0].quantidadeLeitosInativos
        );
        setValue(
          "classificacaoEstabelecimento",
          item.protocoloGerador[0].classificacaoEstabelecimento,
          true
        );
        set_classificacaoEstabelecimento(
          item.protocoloGerador[0].classificacaoEstabelecimento
        );
        setValue("subPrefeitura", item.protocoloGerador[0].subPrefeitura, true);
        set_subPrefeitura(item.protocoloGerador[0].subPrefeitura);

        //Campos novos
        setValue(
          "consumoMensalAgua",
          item.protocoloGerador[0]?.consumoMensalAgua,
          true
        );
        setConsumoMensalAgua(item.protocoloGerador[0]?.consumoMensalAgua);

        setValue(
          "consumoMensalEnergia",
          item.protocoloGerador[0]?.consumoMensalEnergia,
          true
        );
        setConsumoMensalEnergia(item.protocoloGerador[0]?.consumoMensalEnergia);

        setValue(
          "localEmpreendimento",
          item.protocoloGerador[0]?.localEmpreendimento,
          true
        );
        setLocalEmpreendimento(item.protocoloGerador[0]?.localEmpreendimento);

        setValue(
          "numeroColaboradores",
          item.protocoloGerador[0]?.numeroColaboradores,
          true
        );
        setNumeroColaboradores(item.protocoloGerador[0]?.numeroColaboradores);

        setValue(
          "areaTotal",
          item.protocoloGerador[0]?.areaTotal?.toString()?.replace(".", ","),
          true
        );
        setValue(
          "areaConstruida",
          item.protocoloGerador[0]?.areaConstruida
            ?.toString()
            ?.replace(".", ","),
          true
        );

        setValue(
          "cpfResponsavel",
          item.protocoloGerador[0]?.cpfResponsavel,
          true
        );
        setValue(
          "funcaoResponsavel",
          item.protocoloGerador[0]?.funcaoResponsavel,
          true
        );
        setValue(
          "departamentoResponsavel",
          item.protocoloGerador[0]?.departamentoResponsavel,
          true
        );
        setValue("codigoCNAE", item.protocoloGerador[0]?.codigoCNAE, true);
        setValue("atividadeCNA", item.protocoloGerador[0]?.atividadeCNA, true);
      }
    } else {
      if (!item) {
        api_GET(
          `SetupSolicitacao/GetByAcaoSegmentoCategoria/${opcao.segmento}/${opcao.categoria.categoria_Id}/Novo Cadastro/${tipoGerador}`
        )
          .then((result) => set_setupSolicitacaoAcao(result.data))
          .catch((err) => showMessage("Aviso", err.message, "error", null))
          .finally(() => setLoading(false));
      }
    }
  };

  // Status
  const [status, set_status] = useState("");
  const options_status = [
    { value: "Ativo", label: "Ativo" },
    { value: "Cancelado", label: "Cancelado" },
    { value: "Inativo", label: "Inativo" },
    { value: "Pendente", label: "Pendente" },
    { value: "Vencido", label: "Vencido" },
  ];
  const handleStatus = (value) => {
    set_status(value);
    setValue("status", value, true);
    clearErrors("status");
  };

  // E-Mail
  const handleEmail = (event) => {
    if (event.target.value.length == 0) return;

    ValidaEmail(event.target.value, handleRetornoValidaEmail);
  };

  const handleRetornoValidaEmail = (result) => {
    if (!result.data) {
      showMessage("Aviso", "E-Mail inválido.", "error", null);
      setValue("email", "");
    }
  };

  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);

  // Nome Fantasia
  const handleFantasia = (event) => {
    let result = onlyAlphaNumericAndSpace(event.target.value);
    setValue("fantasia", result);
  };

  // Razão Social
  const handleRazaoSocial = (event) => {
    let result = onlyAlphaNumericAndSpace(event.target.value);
    setValue("razaoSocial", result);
  };

  // Nome do Solicitante
  const handleSolicitante = (event) => {
    let result = onlyAlphaNumericAndSpace(event.target.value);
    setValue("nomeSolicitante", result);
  };

  // Data Vigência
  const handleDataVigencia = (event) => {
    let input_date = event.target.value;

    if (input_date != "" || input_date.length > 0) {
      if (isValidDate(input_date) == false) {
        showMessage("Aviso", "Data de validade inválida.", "warning", null);
        return;
      }
    }
  };

  const [tipoGerador, set_tipoGerador] = useState("Pública");
  const handleTipoGerador = (value) => {
    set_tipoGerador(value.value);
    setValue("tipoGerador", value.value, true);
    clearErrors("tipoGerador");

    if (addNovoGerador && setupSolicitacao.length > 0) {
      api_GET(
        `SetupSolicitacao/SetupSolicitacaoAcao/${value.setupSolicitacao_Id}`
      )
        .then((result) => set_setupSolicitacaoAcao(result.data))
        .catch((err) => showMessage("Aviso", err.message, "error", null))
        .finally(() => setLoading(false));
    }

    if (!item) {
      api_GET(
        `SetupSolicitacao/GetByAcaoSegmentoCategoria/Grande Gerador/${opcao.categoria.categoria_Id}/Novo Cadastro/${value.value}`
      )
        .then((result) => set_setupSolicitacaoAcao(result.data))
        .catch((err) => showMessage("Aviso", err.message, "error", null))
        .finally(() => setLoading(false));
    }
  };

  //SubPrefeitura
  const [optionsSubPrefeitura, set_OptionsSubPrefeitura] = useState([]);
  const [subPrefeitura, set_subPrefeitura] = useState(null);
  const loadOptionsSubPrefeitura = () => {
    api_GET("subprefeitura")
      .then((result) => {
        set_OptionsSubPrefeitura(result.data);
        if (opcao && opcao.categoria.sigla == "RGG") {
          set_subPrefeitura(
            result.data.filter((x) => x.nome == "SP Regula")[0]
          );
          setValue(
            "subPrefeitura",
            result.data.filter((x) => x.nome == "SP Regula")[0],
            true
          );
        }

        if (
          opcao.tipoCadastro == "Protocolo" &&
          opcao.categoria.sigla != "RGG"
        ) {
          if (item != null && item.protocoloGerador.length > 0) {
            set_subPrefeitura(item.protocoloGerador[0].subPrefeitura);
            setValue(
              "subPrefeitura",
              item.protocoloGerador[0].subPrefeitura,
              true
            );
          }
        } else if (
          opcao.tipoCadastro == "Requerimento" &&
          opcao.categoria.sigla != "RGG"
        ) {
          if (item != null && item.requerimentoGerador.length > 0) {
            set_subPrefeitura(item.requerimentoGerador[0].subPrefeitura);
            setValue(
              "subPrefeitura",
              item.requerimentoGerador[0].subPrefeitura,
              true
            );
          }
        }
      })
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };
  const handleSubPrefeitura = (value) => {
    set_subPrefeitura(value);
    setValue("subPrefeitura", value, true);
    clearErrors("subPrefeitura");
  };

  //Classificação do Estabelecimento - Somente para RSS
  const [
    optionsClassificacaoEstabelecimento,
    set_OptionsClassificacaoEstabelecimento,
  ] = useState([]);

  const [classificacaoEstabelecimento, set_classificacaoEstabelecimento] =
    useState(null);
  const loadOptionsClassificacaoEstabelecimento = () => {
    api_GET("ClassificacaoEstabelecimento")
      .then((result) => {
        set_OptionsClassificacaoEstabelecimento(result.data);
        if (opcao.tipoCadastro == "Protocolo") {
          if (item != null && item.protocoloGerador.length > 0) {
            set_classificacaoEstabelecimento(
              item.protocoloGerador[0].classificacaoEstabelecimento
            );
            setValue(
              "classificacaoEstabelecimento",
              item.protocoloGerador[0].classificacaoEstabelecimento,
              true
            );
          }
        } else if (opcao.tipoCadastro == "Requerimento") {
          if (item != null && item.requerimentoGerador.length > 0) {
            set_subPrefeitura(
              item.requerimentoGerador[0].classificacaoEstabelecimento
            );
            setValue(
              "classificacaoEstabelecimento",
              item.requerimentoGerador[0].classificacaoEstabelecimento,
              true
            );
          }
        }
      })
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };
  const handleClassificacaoEstabelecimento = (value) => {
    set_classificacaoEstabelecimento(value);
    setValue("classificacaoEstabelecimento", value, true);
    clearErrors("classificacaoEstabelecimento");
  };

  // Tipo de Estabelecimento - Somente para RSS
  const [optionsTipoEstabelecimento, set_OptionsTipoEstabelecimento] = useState(
    []
  );
  const [tipoEstabelecimento, set_tipoEstabelecimento] = useState(null);
  const loadOptionsTipoEstabelecimento = () => {
    api_GET("TipoEstabelecimento")
      .then((result) => {
        set_OptionsTipoEstabelecimento(result.data);
        if (opcao.tipoCadastro == "Protocolo") {
          if (item != null && item.protocoloGerador.length > 0) {
            set_tipoEstabelecimento(
              item.protocoloGerador[0].tipoEstabelecimento
            );
            setValue(
              "tipoEstabelecimento",
              item.protocoloGerador[0].tipoEstabelecimento,
              true
            );
          }
        } else if (opcao.tipoCadastro == "Requerimento") {
          if (item != null && item.requerimentoGerador.length > 0) {
            set_tipoEstabelecimento(
              item.requerimentoGerador[0].tipoEstabelecimento
            );
            setValue(
              "tipoEstabelecimento",
              item.requerimentoGerador[0].tipoEstabelecimento,
              true
            );
          }
        }
      })
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };
  const handleTipoEstabelecimento = (value) => {
    set_tipoEstabelecimento(value);
    setValue("tipoEstabelecimento", value, true);
    clearErrors("tipoEstabelecimento");
  };

  // Tipo Documento Responsável Técnico - Somente para RSS
  const [tipoDocumentoResponsavelTecnico, set_tipoDocumentoResponsavelTecnico] =
    useState("");
  const [options_tipoDocumentoResponsavelTecnico] = useState([
    { value: "CREA", label: "CREA" },
    { value: "CREFITO", label: "CREFITO" },
    { value: "CRBM", label: "CRBM" },
    { value: "CRF", label: "CRF" },
    { value: "CRM", label: "CRM" },
    { value: "CRMV", label: "CRMV" },
    { value: "CRO", label: "CRO" },
    { value: "CRTH", label: "CRTH" },
    { value: "CRQ", label: "CRQ" },
    { value: "COREN", label: "COREN" },
    { value: "RG", label: "RG" },
    { value: "CRBIO", label: "CRBIO" },
  ]);
  const handleTipoDocumentoResponsavelTecnico = (value) => {
    set_tipoDocumentoResponsavelTecnico(value);
    setValue("tipoDocumentoResponsavelTecnico", value, true);
    clearErrors("tipoDocumentoResponsavelTecnico");
  };

  // Número Colaboradores - (Grande Gerador) RGG
  const [numeroColaboradores, setNumeroColaboradores] = useState("");
  const [optionsNumeroColaboradores] = useState([
    { value: "1-10", label: "1-10" },
    { value: "11-25", label: "11-25" },
    { value: "26-50", label: "26-50" },
    { value: "51-100", label: "51-100" },
    { value: "101-200", label: "101-200" },
    { value: "201-500", label: "201-500" },
    { value: "501-1000", label: "501-1000" },
    { value: "Acima de 1000", label: "Acima de 1000" },
  ]);

  const handleNumeroColaboradores = (value) => {
    setNumeroColaboradores(value);
    setValue("numeroColaboradores", value, true);
    clearErrors("numeroColaboradores");
  };

  // Consumo Mensal Agua - (Grande Gerador) RGG
  const [consumoMensalEnergia, setConsumoMensalEnergia] = useState("");
  const [optionsConsumoMensalEnergia] = useState([
    { value: "0 a 1.000 Kwh", label: "0 a 1.000 Kwh" },
    { value: "1.001 a 2.500 Kwh", label: "1.001 a 2.500 Kwh" },
    { value: "2.501 a 5.000 Kwh", label: "2.501 a 5.000 Kwh" },
    { value: "5.001 a 10.000 Kwh", label: "5.001 a 10.000 Kwh" },
    { value: "10.001 a 15.000 Kwh", label: "10.001 a 15.000 Kwh" },
    { value: "Acima de 15.000 Kwh", label: "Acima de 15.000 Kwh" },
  ]);

  const handleConsumoMensalEnergia = (value) => {
    setConsumoMensalEnergia(value);
    setValue("consumoMensalEnergia", value, true);
    clearErrors("consumoMensalEnergia");
  };

  // Consumo Mensal Agua - (Grande Gerador) RGG
  const [consumoMensalAgua, setConsumoMensalAgua] = useState("");
  const [optionsConsumoMensalAgua] = useState([
    { value: "0 a 100 m³", label: "0 a 100 m³" },
    { value: "101 a 200 m³", label: "101 a 200 m³" },
    { value: "201 a 300 m³", label: "201 a 300 m³" },
    { value: "301 a 400 m³", label: "301 a 400 m³" },
    { value: "401 a 500 m³", label: "401 a 500 m³" },
    { value: "Acima de 500 m³", label: "Acima de 500 m³" },
  ]);

  const handleConsumoMensalAgua = (value) => {
    setConsumoMensalAgua(value);
    setValue("consumoMensalAgua", value, true);
    clearErrors("consumoMensalAgua");
  };

  // Consumo Mensal Agua - (Grande Gerador) RGG
  const [localEmpreendimento, setLocalEmpreendimento] = useState("");
  const [optionsLocalEmpreendimento] = useState([
    { value: "Casa", label: "Casa" },
    { value: "Prédio", label: "Prédio" },
    { value: "Shopping", label: "Shopping" },
    { value: "Galpão", label: "Galpão" },
    { value: "Outros", label: "Outros" },
  ]);

  const handleLocalEmpreendimento = (value) => {
    setLocalEmpreendimento(value);
    setValue("localEmpreendimento", value, true);
    clearErrors("localEmpreendimento");
  };

  // Certificado Curso - Somente para RSS
  const [file_certificadoCurso, set_file_certificadoCurso] = useState(null);
  const handleFileCertificadoCurso = (_file, callback) => {
    if (_file == null) {
      showMessage(
        "Aviso",
        "Não foi possível concluir o anexo do arquivo.",
        "error",
        null
      );
      return;
    }
    set_file_certificadoCurso(_file);
    callback();
  };

  const [tipoIndustria, set_tipoIndustria] = useState("");

  // Número Endereço
  const handleNumeroEndereco = (e) => {
    let result = onlyNumber(e.target.value);
    setValue("numEndereco", result);
  };

  // cep
  const [editarEndereco, set_editarEndereco] = useState(true);
  const handleCEP = (event) => {
    clearErrors("cep");

    if (event.target.value.replace(/[^0-9]/g, "").trim().length < 8) {
      setValue("cep", "");
      showMessage(
        "Aviso",
        "Cep inválido. só é permitido preencher com números",
        "error",
        null
      );
      return;
    }

    GetCEPViaCEP(event.target.value).then((result) => {
      if (
        result.status !== 200 ||
        (result.data.hasOwnProperty("erro") && result.data.erro == "true")
      ) {
        showMessage("Aviso", "Cep não localizado", "warning", null);
        setValue("logradouro", "");
        setValue("bairro", "");
        setValue("cidade", "");
        setValue("uf", "");
        set_editarEndereco(true);
      } else {
        setValue("logradouro", result.data.logradouro);
        setValue("bairro", result.data.bairro);
        setValue("cidade", result.data.localidade);
        setValue("uf", result.data.uf);

        if (
          result.data.logradouro == null ||
          result.data.logradouro.length == 0
        )
          set_editarEndereco(false);
        else set_editarEndereco(true);
      }
    });
  };

  //Ramo de Atividade
  const [ramo, set_ramo] = useState("");
  const [options_ramoAtividade, set_optionsRamoAtividade] = useState([]);

  const loadRamoAtividade = () => {
    api_GET("RamoAtividade")
      .then((result) => {
        let tipos = result.data.map((m, key) => ({
          label: m.descricao,
          value: m.descricao,
        }));
        set_optionsRamoAtividade(tipos);
      })
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };

  const handleRamoAtividade = (value) => {
    set_ramo(value);
    setValue("ramo", value, true);
    clearErrors("ramo");
  };

  // Categoria
  const [categoria, set_categoria] = useState(null);

  const loadDefaultValues = (field) => {
    if (item == null) return "";

    if (opcao.tipoCadastro === "Protocolo") {
      switch (field) {
        case "Telefone":
          return item.protocoloGerador.length > 0
            ? item.protocoloGerador[0].telefone
            : "";
        case "Celular":
          return item.protocoloGerador.length > 0
            ? item.protocoloGerador[0].celular
            : "";
        case "CEP":
          return item.protocoloGerador.length > 0
            ? item.protocoloGerador[0].cep
            : "";
        case "cpfResponsavel":
          return item.protocoloGerador.length > 0
            ? item.protocoloGerador[0]?.cpfResponsavel
            : "";
        default:
          return;
      }
    } else if (opcao.tipoCadastro == "Requerimento") {
      if (item.requerimentoGerador != null) {
        switch (field) {
          case "Telefone":
            return item.requerimentoGerador.length > 0
              ? item.requerimentoGerador[0].telefone
              : "";
          case "Celular":
            return item.requerimentoGerador.length > 0
              ? item.requerimentoGerador[0].celular
              : "";
          case "CEP":
            return item.requerimentoGerador.length > 0
              ? item.requerimentoGerador[0].cep
              : "";
          case "cpfResponsavel":
            return item.requerimentoGerador.length > 0
              ? item.requerimentoGerador[0]?.cpfResponsavel
              : "";
          default:
            return;
        }
      }
    }
  };

  const onSubmit = (data) => {
    setLoading(true);

    if (data.ccm != null && data.ccm.length > 0 && /^\d+$/.test(data.ccm) == false) {
      setLoading(false);
      showMessage(
        "Aviso",
        "CCM inválido. Só é permitido o preenchimento de dígitos numéricos.",
        "warning",
        null
      );
      return;
    }

    if (setupSolicitacaoAcao.setupSolicitacao.categoria.sigla === "RCC") {
      if (isValidDate(data.dataFimVigencia) === false) {
        setLoading(false);
        showMessage("Aviso", "Data de validade inválida.", "warning", null);
        return;
      }

      if (
        setupSolicitacaoAcao.setupSolicitacao.categoria.segmento ===
        "Grande Gerador - PGRCC"
      ) {
        if (
          !data.cpfResponsavel ||
          !data.funcaoResponsavel ||
          !data.departamentoResponsavel ||
          !data.atividadeCNA ||
          !data.codigoCNAE
        ) {
          setLoading(false);
          showMessage(
            "Aviso",
            "Obrigatório preencher todos os campos do responsável técnico pelo projeto",
            "warning",
            null
          );
          return;
        }

        const _cpfNumero = (data?.cpfResponsavel ?? "").replace(/\D/g, "");

        if (_cpfNumero.length !== 11 || !isValidCPF(_cpfNumero)) {
          setLoading(false);
          showMessage(
            "Aviso",
            "CPF do responsável é inválido.",
            "warning",
            null
          );
          return;
        }
      }
    }

    if (setupSolicitacaoAcao.setupSolicitacao.categoria.sigla === "RGG") {
      if (data.telefone == null || data.telefone === "") {
        setLoading(false);
        showMessage(
          "Aviso",
          "Obrigatório indicar um Telefone.",
          "warning",
          null
        );
        return;
      }
    }

    if (setupSolicitacaoAcao.setupSolicitacao.categoria.sigla !== "RGG") {
      let numeroEndereco = onlyNumber(data.numEndereco);
      if (numeroEndereco.length === "" && session === null) {
        setLoading(false);
        showMessage(
          "Aviso",
          "Número de endereço inválido, ou, não informado. Só é permitido o preenchimento de dígitos numéricos.",
          "warning",
          null
        );
        return;
      }
    }

    if (
      data.cep === "" ||
      data.logradouro === "" ||
      data.bairro === "" ||
      data.numEndereco === "" ||
      data.cidade === "" ||
      data.uf === ""
    ) {
      setLoading(false);
      showMessage(
        "Aviso",
        "Obrigatório preencher todos os dados de endereço.",
        "warning",
        null
      );
      return;
    }

    if (
      (session === null ||
        session === null ||
        (session && session.tipoAcesso === "Protocolo")) &&
      classificacaoEstabelecimento == null &&
      setupSolicitacaoAcao.setupSolicitacao.categoria.sigla === "RSS"
    ) {
      setLoading(false);
      showMessage(
        "Aviso",
        "Por favor, preencha o campo de classificação do estabelecimento.",
        "warning",
        null
      );
      return;
    }

    if (permiteManutencao && opcao.tipoCadastro === "Protocolo") {
      let json = carregaJsonProtocolo(data);
      EnviaProtocoloWithProtocoloGerador(json, handleRetornoSubmit);
    } else if (opcao.tipoCadastro === "Requerimento") {
      let json = carregaJsonRequerimento(data);
      EnviaRequerimentoGerador(json, handleRetornoSubmit);
    } else {
      set_identificacao(item);
      handleProximoStep(item);
    }
  };

  const carregaJsonRequerimento = (data) => {
    let json_submit = {
      requerimentoGerador_Id:
        item != null &&
          item.requerimentoGerador != null &&
          item.requerimentoGerador.length > 0
          ? item.requerimentoGerador[0].requerimentoGerador_Id
          : 0,
      requerimento_Id: item != null ? item.requerimento_Id : 0,
      subPrefeitura_Id: subPrefeitura ? subPrefeitura.subPrefeitura_Id : null,
      cpf_Cnpj:
        tipoGerador === "Jurídica" || tipoGerador === "Pública" || tipoGerador === "Jurídica - MEI"
          ? data.cnpj
            .replaceAll("/", "")
            .replaceAll(".", "")
            .replaceAll("-", "")
          : data.cpf.replaceAll(".", "").replaceAll("-", ""),
      nome_Fantasia: data.fantasia == null ? data.responsavel : data.fantasia,
      razaoSocial:
        data.razaoSocial == null
          ? ""
          : (tipoGerador === "Jurídica" || tipoGerador === "Pública" || tipoGerador === "Jurídica - MEI") &&
            data.razaoSocial ===
            data.cnpj
              .replaceAll("/", "")
              .replaceAll(".", "")
              .replaceAll("-", "")
            ? item.nomeSolicitante
            : data.razaoSocial,
      nomeResponsavel: data.responsavel,
      nomeSolicitante:
        data.nomeSolicitante == null ? data.responsavel : data.nomeSolicitante,
      tipoEstabelecimento_Id: tipoEstabelecimento
        ? tipoEstabelecimento.tipoEstabelecimento_Id
        : null,
      quantidadeLeitosAtivos: data.qtdeLeitosAtivos,
      quantidadeLeitosInativos: data.qtdeLeitosInativos,
      classificacaoEstabelecimento_Id: classificacaoEstabelecimento
        ? classificacaoEstabelecimento.classificacaoEstabelecimento_Id
        : null,
      nomeResponsavelTecnico: data.nomeResponsavelTecnico,
      tipoDocumentoResponsavelTecnico:
        tipoDocumentoResponsavelTecnico != null
          ? tipoDocumentoResponsavelTecnico
          : null,
      numeroDocumentoResponsavelTecnico: data.numeroDocumentoResponsavelTecnico,
      arquivoCertificadoResponsavelTecnico:
        file_certificadoCurso != null ? file_certificadoCurso.name : null,
      arquivoCertificadoResponsavelTecnicoBase64:
        file_certificadoCurso != null ? file_certificadoCurso.base64 : null,
      cCM: data.ccm,
      cEP: data.cep ? data.cep.replace(/[^0-9]/g, "") : null,
      logradouro: data.logradouro,
      numEndereco: data.numEndereco,
      complemento: data.complemento,
      bairro: data.bairro,
      cidade: data.cidade,
      uF: data.uf,
      telefone: data.telefone
        .replaceAll("(", "")
        .replaceAll(")", "")
        .replaceAll("-", "")
        .replaceAll(" ", ""),
      celular: data.celular
        .replaceAll("(", "")
        .replaceAll(")", "")
        .replaceAll("-", "")
        .replaceAll(" ", ""),
      ramoAtividade: data.ramo !== "" ? data.ramo : "",
      tipoIndustriaComercio:
        data.tipoIndustriaComercio != null ? data.tipoIndustriaComercio : null,
      dataValidadeCadastro:
        data.dataValidadeCadastro != null ? data.dataValidadeCadastro : null,
      numeroColaboradores:
        numeroColaboradores === "" ? null : numeroColaboradores,
      consumoMensalAgua: consumoMensalAgua === "" ? null : consumoMensalAgua,
      consumoMensalEnergia:
        consumoMensalEnergia === "" ? null : consumoMensalEnergia,
      localEmpreendimento:
        localEmpreendimento === "" ? null : localEmpreendimento,
      areaTotal: data?.areaTotal?.replace(",", "."),
      areaConstruida: data?.areaConstruida?.replace(",", "."),
      requerimento: {
        nomeSolicitante:
          data.nomeSolicitante == null
            ? data.responsavel
            : data.nomeSolicitante,
        email: data.email,
      },
      cpfResponsavel: (data?.cpfResponsavel ?? "").replace(/\D/g, ""),
      funcaoResponsavel: data?.funcaoResponsavel ?? "",
      departamentoResponsavel: data?.departamentoResponsavel ?? "",
      atividadeCNA: data?.atividadeCNA ?? "",
      codigoCNAE: data?.codigoCNAE ?? "",
    };
    return json_submit;
  };

  const carregaJsonProtocolo = (data) => {
    let json_submit = {
      protocolo_Id: item != null ? item.protocolo_Id : 0,
      setupSolicitacaoAcaoNovoCadastro_Id:
        setupSolicitacaoAcao != null
          ? setupSolicitacaoAcao.setupSolicitacaoAcao_Id
          : item.setupSolicitacaoAcaoNovoCadastro_Id,
      numeroProtocolo: item != null ? item.numeroProtocolo : "",
      nomeSolicitante:
        data.nomeSolicitante == null ? data.responsavel : data.nomeSolicitante,
      email: data.email,
      cpf_Cnpj:
        tipoGerador === "Jurídica" || tipoGerador === "Pública" || tipoGerador === "Jurídica - MEI"
          ? data.cnpj
            .replaceAll("/", "")
            .replaceAll(".", "")
            .replaceAll("-", "")
          : data.cpf.replaceAll(".", "").replaceAll("-", ""),
      status: item != null && status === "" ? item.status : status,
      dataFimVigencia:
        session != null &&
          session.tipoAcesso === "AreaRestrita" &&
          data.dataFimVigencia != null
          ? data.dataFimVigencia
          : item.dataFimVigencia,
      usuarioCadastro_Id:
        session != null && session.tipoAcesso === "AreaRestrita"
          ? session.usuario_Id
          : null,
      usuarioUltimaAlteracao_Id:
        session != null && session.tipoAcesso === "AreaRestrita"
          ? session.usuario_Id
          : null,
      etapaCadastro: 1,
      codigoCadastro:
        data != null && data.codigoCadastro !== ""
          ? data.codigoCadastro
          : item != null && item.protocoloGerador.length > 0
            ? item.codigoCadastro
            : "0",
      tipoPessoa:
        optionsTipoGerador.find((tg) => tg.value === data.tipoGerador)?.label ||
        null,
      protocoloGerador: [
        {
          protocoloGerador_Id:
            item != null && item.protocoloGerador.length > 0
              ? item.protocoloGerador[0].protocoloGerador_Id
              : 0,
          protocolo_Id: item != null ? item.protocolo_Id : 0,
          subPrefeitura_Id: subPrefeitura
            ? subPrefeitura.subPrefeitura_Id
            : null,
          cpf_Cnpj:
            tipoGerador === "Jurídica" || tipoGerador === "Jurídica - MEI" || tipoGerador === "Pública"
              ? data.cnpj
                .replaceAll("/", "")
                .replaceAll(".", "")
                .replaceAll("-", "")
              : data.cpf.replaceAll(".", "").replaceAll("-", ""),
          nome_Fantasia:
            data.fantasia == null ? data.responsavel : data.fantasia,
          razaoSocial:
            data.razaoSocial == null
              ? ""
              : (tipoGerador === "Jurídica" || tipoGerador === "Jurídica - MEI" || tipoGerador == "Pública") &&
                data.razaoSocial ===
                data.cnpj
                  .replaceAll("/", "")
                  .replaceAll(".", "")
                  .replaceAll("-", "")
                ? item.nomeSolicitante
                : data.razaoSocial,
          nomeResponsavel: data.responsavel,
          tipoEstabelecimento_Id:
            tipoEstabelecimento != null
              ? tipoEstabelecimento.tipoEstabelecimento_Id
              : null,
          quantidadeLeitosAtivos: data.qtdeLeitosAtivos,
          quantidadeLeitosInativos: data.qtdeLeitosInativos,
          classificacaoEstabelecimento_Id:
            classificacaoEstabelecimento != null
              ? classificacaoEstabelecimento.classificacaoEstabelecimento_Id
              : null,
          nomeResponsavelTecnico: data.nomeResponsavelTecnico,
          tipoDocumentoResponsavelTecnico:
            tipoDocumentoResponsavelTecnico != null
              ? tipoDocumentoResponsavelTecnico
              : null,
          numeroDocumentoResponsavelTecnico:
            data.numeroDocumentoResponsavelTecnico,
          arquivoCertificadoResponsavelTecnico:
            file_certificadoCurso != null ? file_certificadoCurso.name : null,
          arquivoCertificadoResponsavelTecnicoBase64:
            file_certificadoCurso != null ? file_certificadoCurso.base64 : null,
          cCM: data.ccm,
          cEP: data.cep ? data.cep.replace(/[^0-9]/g, "") : null,
          logradouro: data.logradouro,
          numEndereco: data.numEndereco,
          complemento: data.complemento,
          bairro: data.bairro,
          cidade: data.cidade,
          uF: data.uf,
          telefone: data.telefone
            .replaceAll("(", "")
            .replaceAll(")", "")
            .replaceAll("-", "")
            .replaceAll(" ", ""),
          celular: data.celular
            .replaceAll("(", "")
            .replaceAll(")", "")
            .replaceAll("-", "")
            .replaceAll(" ", ""),
          ramoAtividade: data.ramo !== "" ? data.ramo : "",
          tipoIndustriaComercio:
            data.tipoIndustriaComercio != null
              ? data.tipoIndustriaComercio
              : null,
          numeroColaboradores:
            numeroColaboradores === "" ? null : numeroColaboradores,
          consumoMensalAgua:
            consumoMensalAgua === "" ? null : consumoMensalAgua,
          consumoMensalEnergia:
            consumoMensalEnergia === "" ? null : consumoMensalEnergia,
          localEmpreendimento:
            localEmpreendimento === "" ? null : localEmpreendimento,
          areaTotal: data?.areaTotal?.replace(",", "."),
          areaConstruida: data?.areaConstruida?.replace(",", "."),
          cpfResponsavel: (data?.cpfResponsavel ?? "").replace(/\D/g, ""),
          funcaoResponsavel: data?.funcaoResponsavel ?? "",
          departamentoResponsavel: data?.departamentoResponsavel ?? "",
          atividadeCNA: data?.atividadeCNA ?? "",
          codigoCNAE: data?.codigoCNAE ?? "",
        },
      ],
      protocoloJustificativas: [
        {
          protocoloJustificativas_Id:
            item != null &&
              item.protocoloJustificativas != null &&
              item.protocoloJustificativas.length > 0
              ? item.protocoloJustificativas[0].protocoloJustificativas_Id
              : 0,
          protocolo_Id: item != null ? item.protocolo_Id : 0,
          UsuarioJustificativa:
            session != null && session.tipoAcesso == "AreaRestrita"
              ? session.usuario_Id
              : null,
          observacao: data.observacao,
          usuario: data.usuario,
        },
      ],
    };
    return json_submit;
  };

  const handleRetornoSubmit = (result) => {
    setLoading(false);
    set_identificacao(result.data);
    handleProximoStep(result.data);
  };

  const handleAlteracaoCadastro = () => {
    if (setupSolicitacoaAcaoNovoCadastro_Id == null) {
      showMessage(
        "Aviso",
        "Por favor, selecione o tipo do cadastro.",
        "warning",
        null
      );
      return;
    }
    showQuestion(
      "Aviso",
      "Após alterar o tipo de cadastro, verifique se todos os dados estão corretos para o novo tipo. Em seguida, confira o protocolo no card de manutenção correspondente ao novo tipo de cadastro.",
      "question",
      function (retorno) {
        if (retorno) {
          setLoading(true);
          api_PUT(`Protocolo/AlterarTipoCadastro`, {
            protocolo_Id: item.protocolo_Id,
            setupSolicitacoaAcaoNovoCadastro_Id:
              setupSolicitacoaAcaoNovoCadastro_Id,
            usuario_Id: session.usuario_Id,
          })
            .then((result) => {
              showMessage("Sucesso", "Sucesso na operação.", "success", () => {
                history.push("/admin/Manutencao");
              });
            })
            .catch((err) => showMessage("Aviso", err.message, "error", null))
            .finally(() => setLoading(false));
        }
      }
    );
  };

  useEffect(() => {
    if (
      session != null &&
      session.tipoAcesso === "AreaRestrita" &&
      item != null
    )
      loadOpcoesTipoCadastro(item?.setupSolicitacaoAcaoNovoCadastro_Id);

    if (
      session != null &&
      session.tipoAcesso === "AreaRestrita" &&
      item != null &&
      opcao.categoria.sigla !== "RSS"
    )
      set_permiteEditar(true);

    if (opcao.categoria.sigla === "RGG") {
      loadRamoAtividade();
    }
    loadOptionsSubPrefeitura();
    loadOptionsClassificacaoEstabelecimento();
    loadOptionsTipoEstabelecimento();

    if (addNovoGerador) {
      setOptionsTipoGerador(setupSolicitacao);
    }

    if (opcao.tipoCadastro === "Protocolo") loadItemProtocolo();
    else if (opcao.tipoCadastro === "Requerimento") loadItemRequerimento();
  }, [item]);

  return (
    <>
      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>
          Histórico de Justificativas.
        </ModalHeader>
        <ModalBody>
          <Form>
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col" className="">
                      Data da Justificativa
                    </th>
                    <th scope="col">Observação</th>
                    <th scope="col">Usuário</th>
                  </tr>
                </thead>
                <tbody>
                  {item.protocoloJustificativas != undefined &&
                    item.protocoloJustificativas.length > 0 &&
                    item.protocoloJustificativas.map((justificativa) => (
                      <tr>
                        <td>
                          {formateDateandTime(justificativa.dataJustificativa)}
                        </td>
                        <td>{justificativa.observacao}</td>
                        <td>
                          {justificativa.usuario == undefined ||
                            justificativa.usuario == null
                            ? justificativa.usuarioJustificativa
                            : justificativa.usuario.nome}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleModal}>
            OK
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={modalAlteracaoCadastro}
        toggle={toggleAlteracaoCadastroModal}
      >
        <ModalHeader toggle={toggleAlteracaoCadastroModal}>
          Alterar Tipo de Cadastro
        </ModalHeader>
        <ModalBody>
          <Form>
            <Select
              options={opcoes_SetupSolicitacoaAcaoNovoCadastro}
              name="ramo"
              onChange={(e) => {
                setSetupSolicitacoaAcaoNovoCadastro_Id(
                  e.setupSolicitacoaAcaoNovoCadastro_Id
                );
              }}
              getOptionLabel={({ descricaoSetupSolicitacoaAcao }) =>
                descricaoSetupSolicitacoaAcao
              }
              getOptionValue={({ setupSolicitacoaAcaoNovoCadastro_Id }) =>
                setupSolicitacoaAcaoNovoCadastro_Id
              }
              value={opcoes_SetupSolicitacoaAcaoNovoCadastro.filter(
                (f) =>
                  f.setupSolicitacoaAcaoNovoCadastro_Id ==
                  setupSolicitacoaAcaoNovoCadastro_Id
              )}
              placeholder="Selecione"
            />
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleAlteracaoCadastro}>
            Alterar Cadastro
          </Button>
        </ModalFooter>
      </Modal>

      <div>
        <Card className={`card-stats`}>
          <CardBody>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <h2 className="titulo-solicitacao">Identificação </h2>
              <Container style={{ maxWidth: "1000px", margin: "0px auto" }}>
                <Row>
                  <Col md="12">
                    <div className="formPrincipal">
                      <h4
                        style={{
                          borderBottom: "solid 1px #ccc",
                          width: "100%",
                        }}
                      >
                        Dados de Identificação
                      </h4>
                      <h6
                        Style={{ padding: 0, margin: 0 }}
                        className="text-center"
                      >
                        {categoria && categoria.descricao}
                      </h6>
                      {session != null &&
                        session.tipoAcesso === "AreaRestrita" &&
                        permiteManutencao &&
                        opcoes_SetupSolicitacoaAcaoNovoCadastro.length > 0 && (
                          <div className="d-flex align-items-center justify-content-end">
                            <Button
                              color="warning"
                              onClick={toggleAlteracaoCadastroModal}
                            >
                              <i className="fas fa-wrench"></i>
                            </Button>
                          </div>
                        )}
                      <Row>
                        <Col md="4">
                          <FormGroup>
                            <b>
                              <label>Tipo Pessoa</label>{" "}
                            </b>
                            <Select
                              options={optionsTipoGerador}
                              name="tipoGerador"
                              value={optionsTipoGerador.find(
                                (obj) => obj.value === tipoGerador
                              )}
                              onChange={(value) => handleTipoGerador(value)}
                              placeholder="Selecione"
                              ref={(e) =>
                                register(
                                  { name: "tipoGerador" },
                                  { required: false }
                                )
                              }
                              isDisabled={
                                identificacao != null &&
                                  identificacao.cpf_Cnpj !== "" &&
                                  identificacao.protocolo_Id !== 0
                                  ? true
                                  : false
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup>
                            <b>
                              <label>
                                {opcao.categoria.sigla === "RCC" ||
                                  (opcao.categoria.sigla === "RGG" && (
                                    <span className="text-danger">* </span>
                                  ))}
                                {opcao.categoria.sigla === "RSS"
                                  ? "Nome Responsável Legal"
                                  : "Nome Responsável"}
                              </label>
                            </b>
                            <Input
                              type="text"
                              name="responsavel"
                              innerRef={register({
                                required:
                                  session != null &&
                                    session.tipoAcesso === "AreaRestrita" &&
                                    opcao.categoria.sigla === "RSS"
                                    ? false
                                    : opcao.categoria.sigla === "RCC" ||
                                      opcao.categoria.sigla === "RGG"
                                      ? true
                                      : false,
                              })}
                              maxLength="100"
                              readonly={permiteEditar ? false : "readonly"}
                              autoComplete="off"
                            />
                            {errors.responsavel && (
                              <span className="form-control-label text-danger">
                                * Campo Obrigatório
                              </span>
                            )}
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup>
                            <b>
                              <label>
                                <span className="text-danger">* </span>Email
                              </label>
                            </b>
                            <Input
                              type="text"
                              name="email"
                              onBlur={handleEmail}
                              innerRef={register({
                                required:
                                  session != null &&
                                    session.tipoAcesso === "AreaRestrita"
                                    ? false
                                    : true,
                              })}
                              maxLength="200"
                              autoComplete="off"
                            />
                            {errors.email && (
                              <span className="form-control-label text-danger">
                                * Campo Obrigatório
                              </span>
                            )}
                          </FormGroup>
                        </Col>
                        {(tipoGerador === "Jurídica" || tipoGerador === "Jurídica - MEI" || tipoGerador === "Pública") && (
                          <Col md="6">
                            <FormGroup>
                              <b>
                                <label>
                                  <span className="text-danger">* </span>Nome
                                  Fantasia{" "}
                                </label>
                              </b>
                              <Input
                                type="text"
                                name="fantasia"
                                id="fantasia"
                                onBlur={handleFantasia}
                                innerRef={register({
                                  required:
                                    session != null &&
                                      session.tipoAcesso == "AreaRestrita"
                                      ? false
                                      : true,
                                })}
                                maxLength="100"
                                autoComplete="off"
                              />
                              {errors.fantasia && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                            <Tooltip
                              placement="top"
                              isOpen={tooltipOpen}
                              target="fantasia"
                              toggle={toggle}
                            >
                              Caso a empresa não tenha Nome Fantasia, informe a
                              Razão Social
                            </Tooltip>
                          </Col>
                        )}
                        {(tipoGerador === "Jurídica" || tipoGerador === "Jurídica - MEI" || tipoGerador === "Pública") && (
                          <Col md="6">
                            <FormGroup>
                              <b>
                                <label>
                                  <span className="text-danger">* </span>Razão
                                  Social{" "}
                                </label>
                              </b>
                              <Input
                                type="text"
                                name="razaoSocial"
                                id="razaoSocial"
                                onBlur={handleRazaoSocial}
                                innerRef={register({
                                  required:
                                    (session == null ||
                                      session == null ||
                                      (session &&
                                        session.tipoAcesso == "Protocolo")) &&
                                      (opcao.categoria.sigla === "RSS" ||
                                        opcao.categoria.sigla === "RCC" ||
                                        opcao.categoria.sigla === "RGG")
                                      ? true
                                      : session != null &&
                                        session.tipoAcesso == "AreaRestrita" &&
                                        (opcao.categoria.sigla === "RCC" ||
                                          opcao.categoria.sigla === "RGG" ||
                                          opcao.categoria.sigla === "RSS")
                                        ? true
                                        : false,
                                })}
                                maxLength="100"
                                autoComplete="off"
                              />
                              {errors.razaoSocial && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                        )}
                        <Col md="12">
                          <FormGroup>
                            <b>
                              <label>
                                <span className="text-danger">* </span>Nome
                                Solicitante{" "}
                                <a href="#" id="questionNomeSolicitante">
                                  <i className="fas fa-question-circle"></i>
                                </a>
                                <UncontrolledTooltip
                                  target="questionNomeSolicitante"
                                  placement="top"
                                >
                                  Nome que aparecerá na tela inicial.
                                </UncontrolledTooltip>
                              </label>
                            </b>
                            <Input
                              type="text"
                              name="nomeSolicitante"
                              id="nomeSolicitante"
                              onKeyUp={handleSolicitante}
                              innerRef={register({
                                required: session ? false : true,
                              })}
                              maxLength="50"
                              autoComplete="off"
                            />
                            {errors.nomeSolicitante && (
                              <span className="form-control-label text-danger">
                                * Campo Obrigatório
                              </span>
                            )}
                          </FormGroup>
                        </Col>
                        {(tipoGerador === "Jurídica" || tipoGerador === "Jurídica - MEI" || tipoGerador === "Pública") && (
                          <Col md="3">
                            <FormGroup>
                              <b>
                                <label>CNPJ</label>
                              </b>
                              <InputCNPJ
                                name="cnpj"
                                defaultValue={item != null && item.cpf_Cnpj}
                                inputRef={register({
                                  required:
                                    session != null &&
                                      session.tipoAcesso === "AreaRestrita"
                                      ? true
                                      : false,
                                })}
                                readOnly={
                                  identificacao != null &&
                                    item.cpf_Cnpj.length !== 0
                                    ? true
                                    : false
                                }
                                autoComplete="off"
                              />
                              {errors.cnpj && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                        )}
                        {tipoGerador === "Física" && (
                          <Col md="3">
                            <FormGroup>
                              <b>
                                <label>CPF</label>
                              </b>
                              <InputCPF
                                name="cpf"
                                defaultValue={item != null && item.cpf_Cnpj}
                                inputRef={register({
                                  required:
                                    session != null &&
                                      session.tipoAcesso == "AreaRestrita"
                                      ? true
                                      : false,
                                })}
                                readOnly={
                                  identificacao != null &&
                                    item.cpf_Cnpj.length != 0
                                    ? true
                                    : false
                                }
                                autoComplete="off"
                              />
                              {errors.cpf && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                        )}
                        <Col md="3">
                          <FormGroup>
                            <b>
                              <label>
                                <span className="text-danger">* </span>CCM
                              </label>
                            </b>
                            <Input
                              type="text"
                              name="ccm"
                              innerRef={register({
                                required: session ? false : true,
                              })}
                              onChange={(event) =>
                                setValue(
                                  "ccm",
                                  event.target.value.replace(/\D/g, "").slice(0, 10)
                                )
                              }
                            />
                            {errors.ccm && (
                              <span className="form-control-label text-danger">
                                * Campo Obrigatório
                              </span>
                            )}
                          </FormGroup>
                        </Col>
                        {session != null &&
                          session.tipoAcesso == "AreaRestrita" &&
                          session.usuario_Id != null && (
                            <Col md="3">
                              <FormGroup>
                                <b>
                                  <label>Número Cadastro</label>
                                </b>
                                <Input
                                  type="text"
                                  name="codigoCadastro"
                                  innerRef={register({
                                    required: session ? false : true,
                                  })}
                                  maxLength="10"
                                />
                                {errors.codigoCadastro && (
                                  <span className="form-control-label text-danger">
                                    * Campo Obrigatório
                                  </span>
                                )}
                              </FormGroup>
                            </Col>
                          )}
                        <Col md="3">
                          <FormGroup>
                            <b>
                              <label>
                                <span className="text-danger">* </span>Telefone
                              </label>
                            </b>
                            <InputTELEFONE
                              type="text"
                              name="telefone"
                              defaultValue={loadDefaultValues("Telefone")}
                              inputRef={register({
                                required: session ? false : true,
                              })}
                            />
                            {errors.telefone && (
                              <span className="form-control-label text-danger">
                                * Campo Obrigatório
                              </span>
                            )}
                          </FormGroup>
                        </Col>
                        <Col md="3">
                          <FormGroup>
                            <b>
                              <label>Celular</label>
                            </b>
                            <InputTELEFONE
                              type="text"
                              name="celular"
                              defaultValue={loadDefaultValues("Celular")}
                              inputRef={register({ required: false })}
                            />
                          </FormGroup>
                        </Col>
                        {(tipoGerador === "Jurídica" || tipoGerador === "Jurídica - MEI" || tipoGerador === "Pública") && (
                          <Col
                            md="4"
                            className={
                              setupSolicitacaoAcao &&
                                setupSolicitacaoAcao.setupSolicitacao.categoria
                                  .sigla === "RCC"
                                ? ""
                                : "d-none"
                            }
                          >
                            <FormGroup>
                              <b>
                                <label>Tipo Indústria/Comércio</label>
                              </b>
                              <Input
                                type="text"
                                name="tipoIndustriaComercio"
                                innerRef={register({ required: false })}
                                maxLength="100"
                                readonly={
                                  tipoIndustria != null &&
                                    tipoIndustria.length !== 0
                                    ? "readonly"
                                    : false
                                }
                              />
                              {errors.tipoIndustriaComercio && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                        )}
                        {(tipoGerador === "Jurídica" || tipoGerador === "Jurídica - MEI" || tipoGerador === "Pública") && (
                          <Col
                            md="4"
                            className={
                              setupSolicitacaoAcao &&
                                setupSolicitacaoAcao.setupSolicitacao.categoria
                                  .sigla === "RCC"
                                ? ""
                                : "d-none"
                            }
                          >
                            <FormGroup>
                              <b>
                                <label>Ramo</label>
                              </b>
                              <Input
                                type="text"
                                name="ramo"
                                innerRef={register({ required: false })}
                                maxLength="100"
                                readonly={
                                  ramo != null && ramo.length !== 0
                                    ? "readonly"
                                    : false
                                }
                              />
                              {errors.ramo && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                        )}
                        {setupSolicitacaoAcao &&
                          setupSolicitacaoAcao.setupSolicitacao.categoria
                            .sigla === "RGG" && (
                            <Col md="4">
                              <FormGroup>
                                <b>
                                  <label>
                                    <span className="text-danger">*</span> Ramo
                                  </label>
                                </b>
                                <Select
                                  options={options_ramoAtividade}
                                  name="ramo"
                                  onChange={(e) => {
                                    handleRamoAtividade(e.value);
                                  }}
                                  getOptionLabel={({ label }) => label}
                                  getOptionValue={({ value }) => value}
                                  value={options_ramoAtividade.filter(
                                    (f) => f.value == ramo
                                  )}
                                  placeholder="Selecione"
                                  ref={(e) =>
                                    register(
                                      { name: "ramo" },
                                      { required: true }
                                    )
                                  }
                                />
                                {errors.ramo && (
                                  <span className="form-control-label text-danger">
                                    * Campo Obrigatório
                                  </span>
                                )}
                              </FormGroup>
                            </Col>
                          )}
                        <Col
                          md="4"
                          className={
                            setupSolicitacaoAcao &&
                              setupSolicitacaoAcao.setupSolicitacao.categoria
                                .sigla == "RSS"
                              ? ""
                              : "d-none"
                          }
                        >
                          <FormGroup>
                            <b>
                              <label>Tipo de Estabelecimento</label>
                            </b>
                            <Select
                              options={optionsTipoEstabelecimento}
                              getOptionLabel={(option) => option.descricao}
                              getOptionValue={(option) =>
                                option.tipoEstabelecimento_Id
                              }
                              name="tipoEstabelecimento"
                              onChange={(e) => {
                                handleTipoEstabelecimento(e);
                              }}
                              value={tipoEstabelecimento}
                              placeholder="Selecione"
                              ref={(e) =>
                                register(
                                  { name: "tipoEstabelecimento" },
                                  {
                                    required:
                                      session === null &&
                                      setupSolicitacaoAcao &&
                                      setupSolicitacaoAcao.setupSolicitacao
                                        .categoria.sigla == "RSS",
                                  }
                                )
                              }
                              isDisabled={!permiteEditar}
                            />
                            {errors.tipoEstabelecimento && (
                              <span className="form-control-label text-danger">
                                * Campo Obrigatório
                              </span>
                            )}
                          </FormGroup>
                        </Col>
                        <Col
                          md="4"
                          className={
                            setupSolicitacaoAcao &&
                              setupSolicitacaoAcao.setupSolicitacao.categoria
                                .sigla == "RSS" &&
                              tipoEstabelecimento &&
                              tipoEstabelecimento.descricao == "HOSPITAL"
                              ? ""
                              : "d-none"
                          }
                        >
                          <FormGroup>
                            <b>
                              <label>Qtde. Leitos Ativos</label>
                            </b>
                            <Input
                              type="number"
                              name="qtdeLeitosAtivos"
                              innerRef={register({
                                required:
                                  (session == null ||
                                    (session &&
                                      session.tipoAcesso == "Protocolo")) &&
                                  setupSolicitacaoAcao &&
                                  setupSolicitacaoAcao.setupSolicitacao
                                    .categoria.sigla == "RSS" &&
                                  tipoEstabelecimento &&
                                  tipoEstabelecimento.descricao == "HOSPITAL",
                              })}
                              maxLength="10"
                              readonly={permiteEditar ? false : "readonly"}
                            />
                            {errors.qtdeLeitosAtivos && (
                              <span className="form-control-label text-danger">
                                * Campo Obrigatório
                              </span>
                            )}
                          </FormGroup>
                        </Col>
                        <Col
                          md="4"
                          className={
                            setupSolicitacaoAcao &&
                              setupSolicitacaoAcao.setupSolicitacao.categoria
                                .sigla == "RSS" &&
                              tipoEstabelecimento &&
                              tipoEstabelecimento.descricao == "HOSPITAL"
                              ? ""
                              : "d-none"
                          }
                        >
                          <FormGroup>
                            <b>
                              <label>Qtde. Leitos Inativos</label>
                            </b>
                            <Input
                              type="number"
                              name="qtdeLeitosInativos"
                              innerRef={register({
                                required:
                                  (session == null ||
                                    (session &&
                                      session.tipoAcesso == "Protocolo")) &&
                                  setupSolicitacaoAcao &&
                                  setupSolicitacaoAcao.setupSolicitacao
                                    .categoria.sigla == "RSS" &&
                                  tipoEstabelecimento &&
                                  tipoEstabelecimento.descricao == "HOSPITAL",
                              })}
                              maxLength="10"
                              readonly={permiteEditar ? false : "readonly"}
                            />
                            {errors.qtdeLeitosInativos && (
                              <span className="form-control-label text-danger">
                                * Campo Obrigatório
                              </span>
                            )}
                          </FormGroup>
                        </Col>
                        <Col
                          md="8"
                          className={
                            setupSolicitacaoAcao &&
                              setupSolicitacaoAcao.setupSolicitacao.categoria
                                .sigla == "RSS"
                              ? ""
                              : "d-none"
                          }
                        >
                          <FormGroup>
                            <b>
                              <label>Classificação do Estabelecimento</label>
                            </b>
                            <Select
                              options={optionsClassificacaoEstabelecimento}
                              getOptionLabel={(option) => option.descricao}
                              getOptionValue={(option) =>
                                option.classificacaoEstabelecimento_Id
                              }
                              name="classificacaoEstabelecimento"
                              onChange={(e) => {
                                handleClassificacaoEstabelecimento(e);
                              }}
                              value={classificacaoEstabelecimento}
                              placeholder="Selecione"
                              ref={(e) =>
                                register(
                                  { name: "classificacaoEstabelecimento" },
                                  {
                                    required:
                                      (session == null ||
                                        (session &&
                                          session.tipoAcesso == "Protocolo")) &&
                                      setupSolicitacaoAcao &&
                                      setupSolicitacaoAcao.setupSolicitacao
                                        .categoria.sigla == "RSS",
                                  }
                                )
                              }
                              isDisabled={!permiteEditar}
                            />
                            {errors.classificacaoEstabelecimento && (
                              <span className="form-control-label text-danger">
                                * Campo Obrigatório
                              </span>
                            )}
                          </FormGroup>
                        </Col>
                        {session != null &&
                          session.tipoAcesso == "AreaRestrita" &&
                          session.usuario_Id != null &&
                          setupSolicitacaoAcao &&
                          (setupSolicitacaoAcao?.setupSolicitacao.categoria
                            .sigla == "RCC" ||
                            setupSolicitacaoAcao?.setupSolicitacao.categoria
                              .sigla == "RGG") && (
                            <Col md="3">
                              <FormGroup>
                                <b>
                                  <label>Validade</label>
                                </b>
                                <Input
                                  type="date"
                                  name="dataFimVigencia"
                                  defaultValue={
                                    item?.dataFimVigencia
                                      ? item.dataFimVigencia.split("T")[0]
                                      : ""
                                  }
                                  innerRef={register({
                                    required: session ? false : true,
                                  })}
                                  onBlur={handleDataVigencia}
                                />
                                {errors.dataFimVigencia && (
                                  <span className="form-control-label text-danger">
                                    * Campo Obrigatório
                                  </span>
                                )}
                              </FormGroup>
                            </Col>
                          )}
                        {session != null &&
                          session.tipoAcesso == "AreaRestrita" &&
                          session.usuario_Id != null && (
                            <Col md="3">
                              <FormGroup>
                                <b>
                                  <label>Status</label>
                                </b>
                                <Select
                                  options={options_status}
                                  name="status"
                                  onChange={(e) => {
                                    handleStatus(e.value);
                                  }}
                                  getOptionLabel={({ label }) => label}
                                  getOptionValue={({ value }) => value}
                                  value={
                                    status != "" &&
                                    options_status.find(
                                      (obj) => obj.value === status
                                    )
                                  }
                                  placeholder="Selecione"
                                  ref={(e) =>
                                    register(
                                      { name: "status" },
                                      {
                                        required:
                                          session == null ||
                                            (session &&
                                              session.tipoAcesso == "Protocolo")
                                            ? false
                                            : true,
                                      }
                                    )
                                  }
                                  isDisabled={!permiteEditar}
                                />
                                {errors.status && (
                                  <span className="form-control-label text-danger">
                                    * Campo Obrigatório
                                  </span>
                                )}
                              </FormGroup>
                            </Col>
                          )}
                        {opcao?.categoria?.segmento == "Grande Gerador" &&
                          opcao?.categoria?.sigla == "RGG" && (
                            <>
                              <Col md="12">
                                <h4
                                  style={{
                                    borderBottom: "solid 1px #ccc",
                                    width: "100%",
                                  }}
                                >
                                  Dados Adicionais
                                </h4>
                              </Col>
                              <Col md="4">
                                <FormGroup>
                                  <b>
                                    <label>Número de Colaboradores</label>
                                  </b>
                                  <Select
                                    options={optionsNumeroColaboradores}
                                    name="numeroColaboradores"
                                    onChange={(e) => {
                                      handleNumeroColaboradores(e.value);
                                    }}
                                    getOptionLabel={({ label }) => label}
                                    getOptionValue={({ value }) => value}
                                    value={
                                      numeroColaboradores != "" &&
                                      optionsNumeroColaboradores.find(
                                        (obj) =>
                                          obj.value === numeroColaboradores
                                      )
                                    }
                                    placeholder="Selecione"
                                    ref={(e) =>
                                      register(
                                        { name: "numeroColaboradores" },
                                        { required: true }
                                      )
                                    }
                                    isDisabled={!permiteEditar}
                                  />
                                  {errors.numeroColaboradores && (
                                    <span className="form-control-label text-danger">
                                      * Campo Obrigatório
                                    </span>
                                  )}
                                </FormGroup>
                              </Col>
                              <Col md="4">
                                <FormGroup>
                                  <b>
                                    <label>Consumo mensal de Energia</label>
                                  </b>
                                  <Select
                                    options={optionsConsumoMensalEnergia}
                                    name="consumoMensalAgua"
                                    onChange={(e) => {
                                      handleConsumoMensalEnergia(e.value);
                                    }}
                                    getOptionLabel={({ label }) => label}
                                    getOptionValue={({ value }) => value}
                                    value={
                                      consumoMensalEnergia != "" &&
                                      optionsConsumoMensalEnergia.find(
                                        (obj) =>
                                          obj.value === consumoMensalEnergia
                                      )
                                    }
                                    placeholder="Selecione"
                                    ref={(e) =>
                                      register(
                                        { name: "consumoMensalEnergia" },
                                        { required: true }
                                      )
                                    }
                                    isDisabled={!permiteEditar}
                                  />
                                  {errors.consumoMensalEnergia && (
                                    <span className="form-control-label text-danger">
                                      * Campo Obrigatório
                                    </span>
                                  )}
                                </FormGroup>
                              </Col>
                              <Col md="4">
                                <FormGroup>
                                  <b>
                                    <label>Consumo Mensal de Água</label>
                                  </b>
                                  <Select
                                    options={optionsConsumoMensalAgua}
                                    name="consumoMensalAgua"
                                    onChange={(e) => {
                                      handleConsumoMensalAgua(e.value);
                                    }}
                                    getOptionLabel={({ label }) => label}
                                    getOptionValue={({ value }) => value}
                                    value={
                                      consumoMensalAgua != "" &&
                                      optionsConsumoMensalAgua.find(
                                        (obj) => obj.value === consumoMensalAgua
                                      )
                                    }
                                    placeholder="Selecione"
                                    ref={(e) =>
                                      register(
                                        { name: "consumoMensalAgua" },
                                        { required: true }
                                      )
                                    }
                                    isDisabled={!permiteEditar}
                                  />
                                  {errors.consumoMensalAgua && (
                                    <span className="form-control-label text-danger">
                                      * Campo Obrigatório
                                    </span>
                                  )}
                                </FormGroup>
                              </Col>
                              <Col md="4">
                                <FormGroup>
                                  <b>
                                    <label>Local do Empreendimento</label>
                                  </b>
                                  <Select
                                    options={optionsLocalEmpreendimento}
                                    name="localEmpreendimento"
                                    onChange={(e) => {
                                      handleLocalEmpreendimento(e.value);
                                    }}
                                    getOptionLabel={({ label }) => label}
                                    getOptionValue={({ value }) => value}
                                    value={
                                      localEmpreendimento != "" &&
                                      optionsLocalEmpreendimento.find(
                                        (obj) =>
                                          obj.value === localEmpreendimento
                                      )
                                    }
                                    placeholder="Selecione"
                                    ref={(e) =>
                                      register(
                                        { name: "localEmpreendimento" },
                                        { required: true }
                                      )
                                    }
                                    isDisabled={!permiteEditar}
                                  />
                                  {errors.localEmpreendimento && (
                                    <span className="form-control-label text-danger">
                                      * Campo Obrigatório
                                    </span>
                                  )}
                                </FormGroup>
                              </Col>
                              <Col md="4">
                                <FormGroup>
                                  <b>
                                    <label>Área total (m²)</label>
                                  </b>
                                  <Input
                                    type="text"
                                    name="areaTotal"
                                    id="areaTotal"
                                    innerRef={register({
                                      required: true,
                                      pattern: /^\d+(\,\d+)?$/,
                                    })}
                                    onChange={(e) => {
                                      let { value } = e.target;
                                      value = value.replace(/[^\d,]/g, "");
                                      setValue("areaTotal", value);
                                    }}
                                    placeholder="ex: 0,00"
                                  />
                                  {errors.areaTotal && (
                                    <span className="form-control-label text-danger">
                                      * Campo Obrigatório
                                    </span>
                                  )}
                                </FormGroup>
                              </Col>
                              <Col md="4">
                                <FormGroup>
                                  <b>
                                    <label>Área Construída (m²)</label>
                                  </b>
                                  <Input
                                    type="text"
                                    name="areaConstruida"
                                    id="areaConstruida"
                                    innerRef={register({
                                      required: true,
                                      pattern: /^\d+(\,\d+)?$/,
                                    })}
                                    onChange={(e) => {
                                      let { value } = e.target;
                                      value = value.replace(/[^\d,]/g, "");
                                      setValue("areaConstruida", value);
                                    }}
                                    placeholder="ex: 0,00"
                                  />
                                  {errors.areaConstruida && (
                                    <span className="form-control-label text-danger">
                                      * Campo Obrigatório
                                    </span>
                                  )}
                                </FormGroup>
                              </Col>
                            </>
                          )}
                      </Row>
                    </div>
                  </Col>
                </Row>

                <Row
                  className={
                    setupSolicitacaoAcao &&
                      setupSolicitacaoAcao.setupSolicitacao.categoria.sigla ==
                      "RSS"
                      ? ""
                      : "d-none"
                  }
                >
                  <Col md="12">
                    <div className="formPrincipal">
                      <h4
                        style={{
                          borderBottom: "solid 1px #ccc",
                          width: "100%",
                        }}
                      >
                        Responsável Técnico
                      </h4>
                      <Form>
                        <Row>
                          <Col md="3" lg="3">
                            <FormGroup>
                              <b>
                                <label>Nome Responsável Técnico</label>
                              </b>
                              <Input
                                type="text"
                                name="nomeResponsavelTecnico"
                                innerRef={register({
                                  required:
                                    (session == null ||
                                      (session &&
                                        session.tipoAcesso == "Protocolo")) &&
                                    setupSolicitacaoAcao &&
                                    setupSolicitacaoAcao.setupSolicitacao
                                      .categoria.sigla == "RSS",
                                })}
                                maxLength="100"
                                readonly={permiteEditar ? false : "readonly"}
                              />
                              {errors.nomeResponsavelTecnico && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>

                          <Col md="3">
                            <FormGroup>
                              <b>
                                <label>Tipo Documento</label>
                              </b>
                              <Select
                                options={
                                  options_tipoDocumentoResponsavelTecnico
                                }
                                name="tipoDocumentoResponsavelTecnico"
                                onChange={(e) => {
                                  handleTipoDocumentoResponsavelTecnico(
                                    e.value
                                  );
                                }}
                                getOptionLabel={({ label }) => label}
                                getOptionValue={({ value }) => value}
                                value={
                                  tipoDocumentoResponsavelTecnico != "" &&
                                  options_tipoDocumentoResponsavelTecnico.find(
                                    (obj) =>
                                      obj.value ===
                                      tipoDocumentoResponsavelTecnico
                                  )
                                }
                                placeholder="Selecione"
                                ref={(e) =>
                                  register(
                                    { name: "tipoDocumentoResponsavelTecnico" },
                                    {
                                      required:
                                        (session == null ||
                                          (session &&
                                            session.tipoAcesso ==
                                            "Protocolo")) &&
                                        setupSolicitacaoAcao &&
                                        setupSolicitacaoAcao.setupSolicitacao
                                          .categoria.sigla == "RSS",
                                    }
                                  )
                                }
                                isDisabled={!permiteEditar}
                              />
                              {errors.tipoDocumentoResponsavelTecnico && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                          <Col md="3" lg="3">
                            <FormGroup>
                              <b>
                                <label>Número Documento</label>
                              </b>
                              <Input
                                type="text"
                                name="numeroDocumentoResponsavelTecnico"
                                innerRef={register({
                                  required:
                                    (session == null ||
                                      (session &&
                                        session.tipoAcesso == "Protocolo")) &&
                                    setupSolicitacaoAcao &&
                                    setupSolicitacaoAcao.setupSolicitacao
                                      .categoria.sigla == "RSS",
                                })}
                                maxLength="20"
                                readonly={permiteEditar ? false : "readonly"}
                              />
                              {errors.numeroDocumentoResponsavelTecnico && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                          <Col md="3" lg="3">
                            <FormGroup>
                              <b>
                                <p style={{ color: "#888" }}>
                                  Certificado do Curso ou CRBio
                                </p>
                              </b>
                              <InputPDF
                                name="arquivoCertificadoCurso"
                                image={file_certificadoCurso}
                                height="3rem"
                                width="3rem"
                                documento_id={0}
                                handlefile={handleFileCertificadoCurso}
                              ></InputPDF>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12" lg="12">
                            * Se não possuir registro no Conselho Regional,
                            informe seu RG e importe o Certificado do Curso ou
                            CRBio na área de atuação.
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  </Col>
                </Row>

                <Row
                  className={
                    setupSolicitacaoAcao &&
                      setupSolicitacaoAcao?.setupSolicitacao?.categoria?.segmento ===
                      "Grande Gerador - PGRCC"
                      ? ""
                      : "d-none"
                  }
                >
                  <Col md="12">
                    <div className="formPrincipal">
                      <h4
                        style={{
                          borderBottom: "solid 1px #ccc",
                          width: "100%",
                        }}
                      >
                        Responsável Técnico Pelo Projeto
                      </h4>
                      <Form>
                        <Row>
                          <Col md="12" lg="4">
                            <FormGroup>
                              <b>
                                <label>
                                  <span className="text-danger">*</span> CPF do
                                  Responsável
                                </label>
                              </b>
                              <InputCPF
                                name="cpfResponsavel"
                                defaultValue={loadDefaultValues(
                                  "cpfResponsavel"
                                )}
                                inputRef={register({
                                  required: (session == null ||
                                    (session &&
                                      session.tipoAcesso ==
                                      "Protocolo")) &&
                                    setupSolicitacaoAcao &&
                                    setupSolicitacaoAcao.setupSolicitacao.categoria.segmento === "Grande Gerador - PGRCC",
                                })
                                }
                                autoComplete="off"
                              />
                              {errors.cpf && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>

                          <Col md="12" lg="4">
                            <FormGroup>
                              <b>
                                <label>
                                  <span className="text-danger">*</span>
                                  Função do Reponsável
                                </label>
                              </b>
                              <Input
                                type="text"
                                name="funcaoResponsavel"
                                maxLength="30"
                                innerRef={register({
                                  required: (session == null ||
                                    (session &&
                                      session.tipoAcesso ==
                                      "Protocolo")) &&
                                    setupSolicitacaoAcao &&
                                    setupSolicitacaoAcao?.setupSolicitacao?.categoria?.segmento === "Grande Gerador - PGRCC",
                                })
                                }
                              />
                              {errors.funcaoResponsavel && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>

                          <Col md="12" lg="4">
                            <FormGroup>
                              <b>
                                <label>
                                  <span className="text-danger">*</span>
                                  Departamento do Reponsável
                                </label>
                              </b>
                              <Input
                                type="text"
                                name="departamentoResponsavel"
                                maxLength="30"
                                innerRef={register({
                                  required: (session == null ||
                                    (session &&
                                      session.tipoAcesso ==
                                      "Protocolo")) &&
                                    setupSolicitacaoAcao &&
                                    setupSolicitacaoAcao?.setupSolicitacao?.categoria?.segmento === "Grande Gerador - PGRCC",
                                })
                                }
                              />
                              {errors.departamentoResponsavel && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>

                          <Col md="12" lg="4">
                            <FormGroup>
                              <b>
                                <label>
                                  <span className="text-danger">*</span>
                                  Código CNAE
                                </label>
                              </b>
                              <Input
                                type="text"
                                name="codigoCNAE"
                                maxLength="10"
                                innerRef={register({
                                  required: (session == null ||
                                    (session &&
                                      session.tipoAcesso ==
                                      "Protocolo")) &&
                                    setupSolicitacaoAcao &&
                                    setupSolicitacaoAcao?.setupSolicitacao?.categoria?.segmento === "Grande Gerador - PGRCC",
                                })
                                }
                              />
                              {errors.codigoCNAE && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>

                          <Col md="12" lg="4">
                            <FormGroup>
                              <b>
                                <label>
                                  <span className="text-danger">*</span>
                                  Atividade CNA
                                </label>
                              </b>
                              <Input
                                type="text"
                                name="atividadeCNA"
                                maxLength="100"
                                innerRef={register({
                                  required:
                                    (session == null ||
                                      (session &&
                                        session.tipoAcesso ==
                                        "Protocolo")) &&
                                    setupSolicitacaoAcao &&
                                    setupSolicitacaoAcao?.setupSolicitacao?.categoria?.segmento === "Grande Gerador - PGRCC",
                                })
                                }
                              />
                              {errors.atividadeCNA && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col md="12">
                    <div className="formPrincipal">
                      <h4
                        style={{
                          borderBottom: "solid 1px #ccc",
                          width: "100%",
                        }}
                      >
                        Endereço
                      </h4>
                      <Form>
                        <Row>
                          <Col md="3" lg="3">
                            <FormGroup>
                              <b>
                                <label>
                                  <span className="text-danger">* </span>CEP
                                </label>
                              </b>
                              <InputCEP
                                name="cep"
                                defaultValue={loadDefaultValues("CEP")}
                                onBlur={handleCEP}
                                inputRef={register({
                                  required: session ? false : true,
                                })}
                              />
                              {errors.cep && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                          <Col md="5" lg="5">
                            <FormGroup>
                              <b>
                                <label>
                                  <span className="text-danger">*</span>
                                  Logradouro
                                </label>
                              </b>
                              <Input
                                type="text"
                                name="logradouro"
                                maxLength="100"
                                innerRef={register({
                                  required: session ? false : true,
                                })}
                              />
                              {errors.logradouro && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                          <Col md="4" lg="4">
                            <FormGroup>
                              <b>
                                <label>
                                  <span className="text-danger">*</span>Bairro
                                </label>
                              </b>
                              <Input
                                type="text"
                                name="bairro"
                                maxLength="50"
                                innerRef={register({
                                  required: session ? false : true,
                                })}
                              />
                              {errors.bairro && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                          <Col md="2" lg="2">
                            <FormGroup>
                              <b>
                                <label>
                                  <span className="text-danger">* </span>Número
                                </label>
                              </b>
                              <Input
                                type="number"
                                name="numEndereco"
                                innerRef={register({
                                  required: session ? false : true,
                                })}
                                onChange={handleNumeroEndereco}
                              />
                              {errors.numEndereco && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                          <Col md="3" lg="3">
                            <FormGroup>
                              <b>
                                <label>Complemento</label>
                              </b>
                              <Input
                                type="text"
                                name="complemento"
                                innerRef={register({ required: false })}
                                maxLength="50"
                              />
                            </FormGroup>
                          </Col>
                          <Col md="5" lg="5">
                            <FormGroup>
                              <b>
                                <label>Cidade</label>
                              </b>
                              <Input
                                type="text"
                                readonly="readonly"
                                name="cidade"
                                innerRef={register({
                                  required: session ? false : true,
                                })}
                                maxLength="50"
                              />
                              {errors.cidade && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                          <Col md="2" lg="2">
                            <FormGroup>
                              <b>
                                <label>UF</label>
                              </b>
                              <Input
                                type="text"
                                readonly="readonly"
                                name="uf"
                                innerRef={register({
                                  required: session ? false : true,
                                })}
                                maxLength="2"
                              />
                              {errors.uf && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                          <Col
                            md="6"
                            lg="6"
                            className={
                              opcao.categoria.sigla == "RGG" ? "d-none" : ""
                            }
                          >
                            <FormGroup>
                              <b>
                                <label>Regional / SubPrefeitura</label>{" "}
                              </b>
                              <Select
                                options={optionsSubPrefeitura}
                                getOptionLabel={(option) => option.nome}
                                getOptionValue={(option) =>
                                  option.subPrefeitura_Id
                                }
                                name="subPrefeitura"
                                onChange={(e) => {
                                  handleSubPrefeitura(e);
                                }}
                                value={subPrefeitura}
                                placeholder="Selecione"
                                ref={(e) =>
                                  register(
                                    { name: "subPrefeitura" },
                                    { required: session ? false : true }
                                  )
                                }
                                isDisabled={!permiteEditar}
                              />
                              {errors.subPrefeitura && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                          <Col md="12">
                            <FormGroup>
                              <b>
                                <label>Observação</label>
                              </b>
                              <Input
                                type="textarea"
                                name="observacao"
                                innerRef={register({ required: false })}
                                maxLength="8000"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  </Col>
                  <Col md="4">
                    {session != null &&
                      session.tipoAcesso == "AreaRestrita" &&
                      session.usuario_Id != null && (
                        <Button
                          color="secundary"
                          onClick={() => handleReturn(identificacao)}
                          className="btn-mobile"
                          type="submit"
                        >
                          <i className="fas fa-chevron-left"></i> Voltar
                        </Button>
                      )}
                  </Col>
                  <Col md="4">
                    {session != null &&
                      session.tipoAcesso === "AreaRestrita" &&
                      session.usuario_Id != null &&
                      item?.protocoloJustificativas &&
                      item.protocoloJustificativas.length > 0 && (
                        <Button
                          color="info"
                          onClick={toggleModal}
                          className="btn-mobile"
                          type="button"
                        >
                          <i className="fas fa-info"></i> Justificativas
                        </Button>
                      )}
                  </Col>
                  <Col md="4" className="text-right">
                    <Button
                      color="success"
                      className="btn-mobile"
                      type="submit"
                    >
                      Próxima Etapa <i className="fas fa-chevron-right"></i>
                    </Button>
                  </Col>
                </Row>
              </Container>
            </Form>
          </CardBody>
        </Card>
      </div>
    </>
  );
}
